const state = {
  list: [],
  selectedBlockListEntry: null,
};

const getters = {
  customerBlockList: (state) => state.list,
  selectedBlockListEntry: (state) => state.selectedBlockListEntry,
};

const actions = {
  async fetchCustomerBlockListEntry({ commit }, { id, policyId, blocklistId }) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/domains/block/${blocklistId}?user_id=${id}`
    );

    commit("update", response.data);
    commit("updateBlackistEntry", response.data);
  },

  async fetchCustomerBlockList({ commit }, { id, policyId }) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/domains/block?user_id=${id}`
    );

    commit("setCustomerBlockList", response.data.data);
  },

  async createCustomerBlockListEntry({ commit }, { id, policyId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/block?user_id=${id}`,
      body
    );

    commit("addBlockListEntry", response.data);
  },

  async updateCustomerBlockListEntry(
    { commit },
    { id, policyId, blocklistId, body }
  ) {
    const response = await this._vm.$http.put(
      `/restapi/policies/${policyId}/domains/block/${blocklistId}?user_id=${id}`,
      body
    );

    const index = state.list.findIndex(
      (blocklistEntry) => blocklistEntry.id === response.data.id
    );

    if (index === -1) {
      commit("addBlockListEntry", response.data);
    } else {
      commit("updateBlackistEntry", {
        idx: index,
        locationAddress: response.data,
      });
    }
  },

  async importCustomerBlockListEntries({ commit }, { id, policyId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/block?user_id=${id}`,
      body
    );

    commit("importBlockListEntries", response.data);
  },

  async deleteCustomerBlockListEntries(
    { commit },
    { id, policyId, blocklistId }
  ) {
    const response = await this._vm.$http.delete(
      `/restapi/policies/${policyId}/block/${blocklistId}?user_id=${id}`
    );

    commit("deleteLocationAddress", response.data);
  },
};

const mutations = {
  setCustomerBlockList: (state, data) => (state.list = data),
  setSelectedBlockListEntry: (state, data) =>
    (state.selectedBlockListEntry = data),
  addBlockListEntry: (state, data) => state.list.push(data),
  updateBlackistEntry: (state, data) =>
    (state.list[`${data.idx}`] = data.locationAddress),
  importBlockListEntries: (state, data) =>
    (state.list = [...state.list, ...data]),
  deleteLocationAddress: (state, data) => {
    state.list = state.list.filter((domain) => {
      return domain.id !== parseInt(data.id);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
